import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "row font6-responsive pt-sm-9 pt-5 pb-sm-9 pb-5" };
const _hoisted_2 = /*#__PURE__*/ _createStaticVNode("<div class=\"col-12 col-lg-6 d-flex align-items-center text-lg-left text-center\"><div class=\"contentWrapper\"><img src=\"/images/_new_brand/icons_in_brand_design/icon_zertifikat.png\" alt=\"mySWOOOP ISO-Zertifizierung\" width=\"48\" height=\"48\" class=\"mb-2\"><h2 class=\"h2-responsive mb-md-7 mb-4 text-lg-left text-center\"><span class=\"d-inline-block\">mySWOOOP</span> ist ISO-zertifiziert </h2><p class=\"pb-lg-0 pb-4 pr-xl-7\"> Dies ist nicht nur ein Zeugnis für unser Engagement, sondern zeigt auch, dass wir uns den höchsten Standards in Bezug auf Qualität, Umweltschutz und Arbeitsbedingungen verpflichten. </p></div></div>", 1);
const _hoisted_3 = { class: "col-12 col-lg-6 d-lg-flex align-items-lg-center justify-content-center" };
const _hoisted_4 = {
    key: 0,
    class: "row justify-content-center [ isoSlider ]"
};
const _hoisted_5 = { class: "text-center" };
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
    key: 1,
    class: "row"
};
const _hoisted_9 = { class: "row px-xl-45 px-lg-2 px-45 pt-3 pb-3" };
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_carousel_item = _resolveComponent("v-carousel-item");
    const _component_v_carousel = _resolveComponent("v-carousel");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            (_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_v_carousel, {
                        continuous: true,
                        cycle: true,
                        "show-arrows": false,
                        "hide-delimiters": false,
                        "hide-delimiter-background": "",
                        "delimiter-icon": "icon-circle",
                        height: "280"
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
                                return (_openBlock(), _createBlock(_component_v_carousel_item, { key: index }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("img", {
                                                class: "mb-4",
                                                style: { "max-width": "145px", "object-fit": "contain" },
                                                src: slide.imgPath,
                                                alt: slide.alt
                                            }, null, 8, _hoisted_6),
                                            _createElementVNode("div", {
                                                class: "justify-content-center font7-responsive",
                                                innerHTML: slide.text
                                            }, null, 8, _hoisted_7)
                                        ])
                                    ]),
                                    _: 2
                                }, 1024));
                            }), 128))
                        ]),
                        _: 1
                    })
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (iso, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "col-4 text-center"
                        }, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("img", {
                                    class: "",
                                    style: { "width": "100%", "object-fit": "contain" },
                                    src: iso.imgPath,
                                    alt: iso.alt
                                }, null, 8, _hoisted_10)
                            ]),
                            _createElementVNode("div", {
                                innerHTML: iso.text,
                                class: "row px-1 pb-3 justify-content-center font7-responsive"
                            }, null, 8, _hoisted_11)
                        ]));
                    }), 128))
                ]))
        ])
    ]));
}
